import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Invitation_code_access } from '../models/Invitation_code_access';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class AccessCodeService {

  constructor(private http: HttpClient) { }


  getAccessList(): Promise<Invitation_code_access[]> {
  	  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'access_code_horse_show_list').subscribe((response:any) => {
			if(response.type == 'user_access_list' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		}
	      		reject(error_response);
			});
	});
  }

  getAccessCodeEntryTypeShowIds(): Promise<string[]> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'access_code_entry_types').subscribe((response: any) => {
        if (response && response.type === 'entry_types' && Array.isArray(response.data)) {
          const ids = [...new Set<string>(response.data.map((et: any) => String(et.horse_show_id)))];
          resolve(ids);
        } else {
          resolve([]);
        }
      }, (error_response: any) => {
        reject(error_response instanceof HttpErrorResponse ? error_response.error : error_response);
      });
    });
  }

  checkInvitationCodeAccess(horse_show_id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'invitation_code_access', {
        params: { horse_show_id }
      }).subscribe((response: any) => {
        // handle both a plain response object and a {type, data} wrapped one
        const unlocked = response?.submission_unlocked || response?.data?.submission_unlocked;
        resolve(!!unlocked);
      }, (error_response: any) => {
        reject(error_response instanceof HttpErrorResponse ? error_response.error : error_response);
      });
    });
  }

  submitAccessCode(horse_show_id: string, access_code: string): Promise<string> {
  	let post_data = {
        data: {
          type: 'access_code_claim_request',
          attributes: { access_code: access_code,
          	horse_show_id: horse_show_id }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'access_code',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='access_code_response') {
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error.data ? error.data : JSON.stringify(error));
                  }
                });
            });
  }


}
